/***************************************************************************/
"use client";
/***************************************************************************/

import hsl2hex from "./hsl-2-hex";
import { TCssColorVariable } from "./types";

const hslVariable2hex = (variable: TCssColorVariable) => {
  try {
    //  eslint-disable-next-line no-unsafe-optional-chaining
    if (getComputedStyle) {
      //  eslint-disable-next-line no-unsafe-optional-chaining
      const [h, s, l] = getComputedStyle(document.body)
        ?.getPropertyValue(variable)
        ?.split(" ")
        ?.map((it) => Number(it.replace("%", "")));

      return hsl2hex(h ?? 0, s ?? 0, l ?? 0);
    } else {
      return "#000000";
    }
    //  eslint-disable-next-line @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any
  } catch (err: any) {
    console.error(err);
    return "#000000";
  }
};

export default hslVariable2hex;
